<template>
<transition name="gi-nav-fade">
  <!-- <div class="gi-nav is-fix" :class="{'is-show':ready}" v-show="!transparent"> -->
  <div class="gi-nav-mobile is-fix" :class="{'is-show':ready, 'is-en':isEnLang}">
    <div class="gi-nav-container">
      <div class="nav-item brand-item">
          <a class="logo" href="https://fintechathon.g-ican.com">
          <img class="logo-main" :src="logo" alt="深圳大学、微众银行" />
        </a>
      </div>
      <div class="nav-right">
        <!-- <a class="nav-register" :href="bookLink">获奖团队</a> -->
        <template v-if="isEnLang">
          <div class="nav-register nav-register--international" @click="openRegistration('International Track (Artificial Intelligence)')">International Track (Artificial Intelligence) Registration</div>
        </template>
        <template v-else>
          <a class="nav-register" href="https://apply.g-ican.com" target="_blank" rel="noopener">人工智能赛道报名</a>
          <a class="nav-register" href="templates/data-analysis-registration-guide.docx" download>数据分析赛道报名</a>
        </template>
        <!-- <a class="nav-register" :href="bookLink">获奖名单</a> -->
        <div class="nav-item menu-item" @click="showMobileMenu = !showMobileMenu">
          <a class="gi-nav-hamburger" :class="{'is-active': showMobileMenu}"><i></i><i></i><i></i></a>
        </div>
        <div class="mobile-lang-switch" aria-label="Language switcher">
          <button :class="{ active: !isEnLang }" @click="changeLang('zh-CN')">中</button>
          <span>/</span>
          <button :class="{ active: isEnLang }" @click="changeLang('en-US')">EN</button>
        </div>
      </div>
    </div>

    <transition name="gi-nav-fade">
      <div class="nav-menu is-mobile" v-show="showMobileMenu">
        <ul class="list">
          <div class="list-wrapper">
            <a v-for="m in navData" class="item" :key="m.id" @click="changeNav(m)">
              <span v-if="!m.children">{{m.title}}</span>
              <a class="item-children" v-for="(item, index) in m.children" :key="index" @click.stop="changeNav(item)">{{item.title}}</a>
            </a>
          </div>
          <!-- <a v-else class="item" @click="changeLang('en-US')" style="color: #2b70fb">{{linkText}}</a> -->
          <!-- <a class="register-now" :href="bookLink">获奖团队</a> -->
          <!-- <a class="register-now" :href="bookLink">十强公示</a> -->
          <!-- <a class="register-now" href="/zones/fintechathon/campus2024/awards">入围名单</a> -->
          <!-- <a class="register-now" href="/zones/fintechathon/campus2024/result">结果公布</a> -->
        </ul>
      </div>
    </transition>
  </div>
</transition>

</template>

<script>
import { mapState } from 'vuex'
import * as GlobalLayer from '@/utils/globalLayer'
import internationalRegistrationEn from '@/data/internationalRegistrationEn'
export default {
  props: ['navData', 'logo', 'bookLink'],
  data () {
    return {
      showMobileMenu: false,
      scrollTop: 0,
      screenWidth: 0,
      ready: false,
      lingText: 'ENGLISH'
    }
  },
  created () {
  },
  methods: {
    changeNav (item) {
      this.showMobileMenu = false
      if(/^https?:\/\//.test(item.name)) {
        window.open(item.name)
        return
      }
      this.$emit('changeNav', {name: item.name, isMobile: true})
    },
    changeLang (val) {
      this.showMobileMenu = false
      this.$emit('setLang', val)
    },
    openRegistration () {
      GlobalLayer.createModal(this.$store, {
        isSubjectDetail: true,
        subjectDetail: internationalRegistrationEn
      })
    }
  },
  computed: {
    ...mapState(['isEnLang']),
    linkText () {
      return this.isEnLang ? '中文版' : 'ENGLISH'
    }
  }
}
</script>

<style lang="sass">
// nav
//  container
//    nav-left, nav-middle, nav-right
//      nav-item
//        logo
//          img
//        hanburger
//        nav-menu.is-tablet
//  nav-menu.is-mobile

$nav-container-width: min(94vw, 1100px)
$nav-container-width-m: 92vw
$nav-primary: #1075d4
$nav-height-mobile: 55px
$nav-height-tablet: 65px
$nav-hamburger-size: 25px
$nav-menu-tablet-margin: 0
$nav-menu-mobile-padding: 4vw
$nav-bg: rgba(19,16,26,0.9)
$nav-text: #fff
$nav-link: #1075d4
$nav-text-size: 16px
$nav-z-index: 1000
$nav-speed: .3s

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.nav-register
  height: 28px
  padding: 0 6px
  margin-right: 8px
  background: #DD3840
  line-height: 1.2
  font-size: 9px
  font-weight: 500
  color: #FFF
  display: flex
  align-items: center
  justify-content: center
  text-align: center

.nav-register--international
  min-width: 190px
  font-size: 10px
  border: 1px solid rgba(49, 86, 220, .22)
  border-radius: 10px
  background: #3156dc
  cursor: pointer
  transition: background-color .18s ease, transform .1s ease
  &:hover,
  &:focus-visible
    background: #2849bf
  &:active
    background: #203fa8
    transform: scale(.98)

// Keep the compact Chinese navigation visually aligned with the desktop nav:
// AI is the primary blue action; Data Analytics is the secondary pale-blue action.
.gi-nav-mobile:not(.is-en)
  .nav-right > .nav-register
    border: 1px solid rgba(49, 86, 220, .22)
    border-radius: 8px
    cursor: pointer
    transition: color .18s ease, background-color .18s ease, transform .1s ease
  .nav-right > .nav-register:first-of-type
    color: #fff
    background: #3156dc
  .nav-right > .nav-register:nth-of-type(2)
    color: #3156dc
    background: #eef2ff
  .nav-right > .nav-register:hover,
  .nav-right > .nav-register:focus-visible
    color: #fff
    background: #2849bf
  .nav-right > .nav-register:active
    color: #fff
    background: #203fa8
    transform: scale(.98)

.mobile-lang-switch
  display: flex
  align-items: center
  gap: 2px
  height: 24px
  margin-left: 9px
  padding-left: 8px
  border-left: 1px solid #e0e3e7
  color: #a0a6af
  button
    padding: 3px 1px
    border: 0
    color: inherit
    background: transparent
    font-size: 9px
    cursor: pointer
    &.active
      color: #d83a40
      font-weight: 700
  span
    color: #d6d9de
    font-size: 8px

.gi-nav-hamburger
  cursor: pointer
  display: block
  height: 18px
  width: 18px
  display: flex
  flex-direction: column
  justify-content: space-between
  i
    display: block
    height: 2px
    width: 100%
    background-color: #000000
    transition: all $nav-speed ease-out
  &.is-active
    i
      &:nth-child(1)
        width: 23.2px
        transform: rotate(47deg)
        transform-origin: left top
      &:nth-child(2)
        opacity: 0
      &:nth-child(3)
        width: 23.2px
        transform: rotate(-47deg)
        transform-origin: left bottom

.gi-nav-container
  width: $nav-container-width
  +mobile
    width: $nav-container-width-m
  margin: 0 auto
  display: flex
  justify-content: space-between
  height: 100%

.gi-nav-fade-enter-active, .gi-nav-fade-leave-active
  transition: opacity $nav-speed
.gi-nav-fade-enter, .gi-nav-fade-leave-to
  opacity: 0

.register-now
  display: inline-block
  position: absolute
  bottom: 0
  width: 170px
  height: 40px
  text-align: center
  color: #FFFFFF
  background: #DD3840
  line-height: 40px

.item
  display: flex
  flex-direction: column
  align-items: center

.gi-nav-mobile
  display: flex
  justify-content: space-between
  z-index: $nav-z-index
  white-space: nowrap
  background-color: rgba(255,255,255,.94)
  backdrop-filter: blur(12px)
  height: $nav-height-mobile
  &.is-fix
    position: fixed
    left: 0
    width: 100vw
    top: 0
    .nav-menu.is-mobile
      position: fixed
      display: flex
      justify-content: center
  .nav-left, .nav-middle, .nav-right, .nav-item, .nav-menu.is-tablet
    display: flex
    height: 100%
    flex-grow: 0
    flex-shrink: 0

  .nav-right
    align-items: center

  .nav-item
    align-items: center

  .logo
    display: flex
    height: 50%
    align-items: center
    gap: 6px
    margin-right: 10px
    position: relative
    .logo-main
      width: 126px
      height: auto
    .logo-ican
      width: 38px
      height: auto
      object-fit: contain
  .nav-menu a
    // color: $nav-text
    font-size: $nav-text-size
    &:hover
      color: $nav-link
  .nav-menu.is-tablet
    margin: $nav-menu-tablet-margin

    a:not(:first-child)
      margin-left: 30px

    .nav-item
      position: relative

    .nav-item::after
      content: ''
      position: absolute
      left: 0
      right: 0
      bottom: 0
      height: 4px
      transition: background $nav-speed
      background-color: #000

    .nav-item:hover::after
      background-color: $nav-primary

  .nav-menu.is-mobile
    z-index: $nav-z-index
    position: fixed
    left: 0
    top: $nav-height-mobile
    bottom: 0
    width: 100%
    height: 410px
    padding: $nav-menu-mobile-padding
    // background-color: $nav-bg
    overflow-y: auto
    background-color: #FFFFFF

    .list
      position: relative
      display: flex
      flex-direction: column
      align-items: center
      width: 100%

    .list-wrapper
      width: 100%
      height: 420px
      overflow-y: auto

    .list > .item
      display: flex
      padding: 18px 0
      font-size: $nav-text-size
      line-height: 1
      // border-bottom: 1px solid rgba(255,255,255,.25)
    .item
      padding: 9px 0
      text-align: center

      &:nth-child(n+3)
        padding: 0

    .item-children
      padding: 9px 0
      color: #000000
      +mobile
        width: 100%
  +mobile
    .nav-menu.is-tablet
      display: none

@media screen and (min-width: 769px)
  .gi-nav-mobile
    height: 64px

    .logo
      height: 54%
      margin-right: 18px
      .logo-main
        width: 188px

    .nav-register
      min-width: 122px
      height: 36px
      padding: 0 10px
      margin-right: 10px
      font-size: 12px
    .nav-register--international
      min-width: 210px
      font-size: 11px

    .gi-nav-hamburger
      width: 22px
      height: 20px

    .mobile-lang-switch
      height: 30px
      margin-left: 13px
      padding-left: 12px
      button
        font-size: 12px

    .nav-menu.is-mobile
      top: $nav-height-tablet
      height: auto
      min-height: 360px

@media screen and (min-width: 769px) and (max-width: 920px)
  .gi-nav-mobile
    .logo
      margin-right: 8px
      .logo-main
        width: 150px
    .nav-register
      min-width: 96px
      padding: 0 7px
      margin-right: 7px
      font-size: 10px
    .nav-register--international
      min-width: 170px
      font-size: 9px
    .mobile-lang-switch
      margin-left: 8px
      padding-left: 8px

@media screen and (max-width: 390px)
  .gi-nav-mobile .logo
    gap: 5px
    margin-right: 6px
    .logo-main
      width: 110px
    .logo-ican
      width: 33px

@media screen and (max-width: 600px)
  .gi-nav-mobile:not(.is-en)
    height: 94px
    white-space: normal
    .gi-nav-container
      position: relative
      width: calc(100% - 24px)
    .brand-item
      position: absolute
      top: 9px
      left: 0
      height: 32px
    .logo
      height: 32px
      margin: 0
      .logo-main
        width: 118px
    .nav-right
      position: static
      width: 100%
      height: 100%
    .nav-register
      position: absolute
      bottom: 8px
      width: calc(50% - 4px)
      min-width: 0
      height: 36px
      margin: 0
      padding: 0 10px
      border-radius: 10px
      font-size: 11px
      line-height: 1.2
    .nav-register:first-of-type
      left: 0
    .nav-register:nth-of-type(2)
      right: 0
    .menu-item
      position: absolute
      top: 12px
      right: 56px
      width: 24px
      height: 24px
    .mobile-lang-switch
      position: absolute
      top: 9px
      right: 0
      height: 28px
      margin: 0
      padding-left: 8px
    .nav-menu.is-mobile
      top: 94px

  .gi-nav-mobile.is-en
    height: 94px
    white-space: normal
    .gi-nav-container
      position: relative
      width: calc(100% - 24px)
    .brand-item
      position: absolute
      top: 9px
      left: 0
      height: 32px
    .logo
      height: 32px
      margin: 0
      .logo-main
        width: 118px
    .nav-right
      position: static
      width: 100%
      height: 100%
    .nav-register--international
      position: absolute
      right: 0
      bottom: 8px
      left: 0
      width: 100%
      min-width: 0
      height: 36px
      margin: 0
      padding: 0 12px
      font-size: 10px
      line-height: 1.2
      border-radius: 10px
    .menu-item
      position: absolute
      top: 12px
      right: 56px
      width: 24px
      height: 24px
    .mobile-lang-switch
      position: absolute
      top: 9px
      right: 0
      height: 28px
      margin: 0
      padding-left: 8px
    .nav-menu.is-mobile
      top: 94px
</style>
